module.exports = __webpack_public_path__ + "img/07Jackson.7120df32.png";